import { render, staticRenderFns } from "./empresas.vue?vue&type=template&id=6b4b1886"
import script from "./empresas.vue?vue&type=script&lang=js"
export * from "./empresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports